import { render, staticRenderFns } from "./ResetPasswordCard.vue?vue&type=template&id=58ace667&scoped=true&"
import script from "./ResetPasswordCard.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ace667",
  null
  
)

export default component.exports